import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPlus } from "@fortawesome/free-solid-svg-icons";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useTranslation } from "react-i18next";
import { createPost, s3Upload, getpost, getGameFromSlug } from "../api/user";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { event } from "../utils/event";
import { PreviewVideo } from "./previewVideo";
import { SUBSCRIPTION_ENABLED } from "../utils/utils";
import GameSideBar from "../components/Games/GameSideBar";

const CreatePostPage = (props) => {
  const { postId } = useParams();
  const { t } = useTranslation();
    const game_id = props.gameId ?? null;
  const slug = props.slug ?? null;
  const navigate = useNavigate();
  const [sidebarToggle] = useOutletContext();
  const isMobileView = document.body.clientWidth <= 768;
  const [images, setImages] = useState([]);
  const [description, setDescription] = useState("");
  const [postStatus, setPostStatus] = useState("1");
  const [imgurl, setImgUrls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const user = JSON.parse(localStorage.getItem("userInfo"));
  const [game, setGame] = useState(null);

  const flutter = localStorage.getItem("isFlutterInAppWebViewReady");

  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;

  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const [attachments, setAttachments] = useState("");

  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

  const fetchPost = async (Id) => {
    try {
      const response = await getpost({ post_id: Id });
      if (response) {
        setisDataFeteched(true);
        const postData = response?.data?.data;
        console.log(postData?.post_status, "postData?.post_status ");
        setDescription(postData?.description || "");
        setPostStatus(postData?.post_status);
        const imges = postData?.post_image.map((val, index) => {
          return { id: val?.id, preview: val?.image };
        });
        setImages(imges || []);
        setIsDisabled(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsDisabled(false);
    }
  };


  useEffect(() => {
    const checkGameDates = (start_date, end_date) => {
      const endDate = new Date(end_date.replace(" ", "T")); // Parse game.end_date
      const startDate = new Date(start_date.replace(" ", "T")); // Parse game.start_date
      const today = new Date(); // Get today's date
      today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

      if (today >= startDate && today <= endDate) {
        return true;
      } else {
        return false;
      }
    };

    // const fetchGameId = async (slug) => {
    //   try {
    //     const response = await getGameFromSlug({ slug });
    //     const gameData = response?.data?.data;

    //     if (gameData) {

    //       if(checkGameDates(gameData.start_date, gameData.end_date)){
    //         setGame(gameData);
    //         setLoading(true);
    //       }else{
    //         toast.error("Game is not active");
    //         navigate("/contest/my-games");
    //       }
    //     } else {
    //       toast.error("Game not found");
    //       navigate("/contest/my-games");
    //     }

    //   } catch (error) {
    //     console.error("Error fetching game ID:", error);
    //   }
    // };

    const fetchGameId = async (slug) => {
      try {
        const response = await getGameFromSlug({ slug });
        const gameData = response?.data?.data;

        if (gameData) {
          if (checkGameDates(gameData.start_date, gameData.end_date)) {
            const gameType = localStorage.getItem("game_type");
            const isAuthenticated = localStorage.getItem("isAuthenticated");

            if (gameData.game_type === "private") {
              if (gameType === "private" && !isAuthenticated) {
                // toast.error("You need to authenticate to access this game.");
                // navigate("/contest");
                              setGame(gameData);
              setLoading(false);
              } else if (gameType === "private" && isAuthenticated) {
                setGame(gameData);
                setLoading(false);
              } else {
                // toast.error("You cant access this league withouth password.");
                // navigate("/contest");
              setGame(gameData);
              setLoading(false);
              }
            } else {
              setGame(gameData);
              setLoading(false);
            }
          } else {
                setGame(gameData);
                setLoading(false);
            // toast.error("League is not active");
            // // navigate("/contest/my-games");
            // navigate("/contest/my-games", { state: { viewMode: "member" } });
          }
        } else {
          // toast.error("League not found");
          // navigate("/contest/my-games");
          // navigate("/contest/my-games", { state: { viewMode: "member" } });
        }
      } catch (error) {
        console.error("Error fetching game ID:", error);
      }
    };

    fetchGameId(slug);

    // return () => {
    //   localStorage.removeItem("game_type");
    //   localStorage.removeItem("isAuthenticated");
    // };
  }, [slug]);


  useEffect(() => {
    if (postId) {
      if (!isDataFeteched) fetchPost(postId);
    }
  }, [postId, isDataFeteched]);

  useEffect(() => {
    return () => {
      images.forEach((image) => URL.revokeObjectURL(image.preview));
    };
  }, [images]);

  const handleRemoveImage = (index) => {
    console.log(index, "index1");
    const updatedImages = [...images];
    console.log(updatedImages, "img");
    const deletedImageId = updatedImages[index]?.id;
    console.log(deletedImageId, "dimg");
    updatedImages.splice(index, 1);
    setImages(updatedImages);
    console.log(updatedImages, "uimg");
    const imgs = imgurl.filter((val, index1) => index1 !== index);
    setImgUrls(imgs);
    console.log(imgs, "indexfinaql");
    setDeletedImageIds((prevIds) => {
      const newIds = [...prevIds, deletedImageId];
      return newIds;
    });
  };

  const handleImageUpload = async (e) => {
    const selectedFiles = e.target.files;
    const allowedExtensionsRegex = /\.(jpg|jpeg|png|svg|mp4|mov|avi|wmv)$/i;

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];

      const maxSize = 512 * 1024 * 1024;
      if (!allowedExtensionsRegex.test(file?.name)) {
        toast.error("You can only select either an image or a video!");
        return;
      }
      if (file?.size > maxSize) {
        toast.error("File size should not be greater that 512 Mb!");
        return;
      }
    }

    const newImages = Array.from(selectedFiles)
      .slice(0, 5 - images.length)
      .map((file) => ({
        id: null,
        image: null,
        blob: file,
        preview: URL.createObjectURL(file),
      }));
    setImages((prevImages) => [...prevImages, ...newImages]);

    try {
      setLoading(true);

      const response = await s3Upload(newImages);
      if (response) {
        const imageArray = response.data.data.map((path) => ({ image: path }));
        const imageJsonString = imageArray;
        setImgUrls((prevImages) => [...prevImages, ...imageJsonString]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const dropdownStyle = {
    fontSize: "12px",
    padding: "2px 10px 5px 17px",
    border: "2px solid #35b23c",
    borderRadius: "30px",
    color: "#35b23c",
  };

  const dropdownHandler = (event) => {
    setPostStatus(event.target.value);
  };

  useEffect(() => {
    const handleCustomProfileEvent = (event) => {
      if (event?.detail?.imagePost) {
        const rawData = event.detail.imagePost;
        const files = rawData.split(",");
        const unescapedData = files.map((val) =>
          val.replace(/^\[|\]$/g, "").trim()
        );
        const baseUrl = user?.s3_url;

        const imageUrls = unescapedData.map((image) => ({
          preview: baseUrl + image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
        }));

        const imageUrls1 = unescapedData.map((image) => ({
          image: image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
          preview: image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
        }));

        setImages((prevImages) => [...prevImages, ...imageUrls]);
        setImgUrls((prevImages) => [...prevImages, ...imageUrls1]);
      }
    };

    window.addEventListener("myCustomPostEvent", handleCustomProfileEvent);
    return () => {
      window.removeEventListener("myCustomPostEvent", handleCustomProfileEvent);
    };
  }, [user, window.addEventListener]);

  const handleCreateOrUpdatePost = async () => {
    setLoading(true);
    const body = {
      description: description || null,
      caption: null,
      tag: null,
      post_status: postStatus || null,
    };
    if (imgurl.length > 0) {
      body.image_json = JSON.stringify(imgurl);
    } else {
      body.imageJsonString = "";
    }
    if (!body.description && !body.image_json) {
      toast.error("Either description or image is required");
      setLoading(false);
      return;
    }
    setIsDisabled(true);
    try {
      if (postId) {
        const body1 = {
          description: description || null,
          caption: "",
          tag: "",
          post_status: postStatus,
          post_id: postId,
          delete_images: deletedImageIds,
        };

          if (game_id) {
            body1.game_id = game_id;
          }

        if (imgurl.length > 0) {
          body1.image_json = JSON.stringify(imgurl);
        }
        const response = await createPost(body1);
        if (response.status === 200) {
          setLoading(false);
          setIsDisabled(false);
          localStorage.removeItem("imagePost");
          toast.success(response.data.message);
          if(game_id){
             navigate(`/${slug}/feeds`);
          }else{
          navigate("/feed");
          }
        } else if (response.status === 400) {
          setLoading(false);
          setIsDisabled(false);
          toast.error(response.data.message);
        }
      } else {
            if (game_id) {
              body.game_id = game_id;
            }

        const response = await createPost(body);
        if (response.status === 200) {
          setLoading(false);
          setIsDisabled(false);
          localStorage.removeItem("imagePost");
          toast.success(response.data.message);
          if(game_id){
              navigate(`/${slug}/feeds`);
          }else{
          navigate("/feed");
          }
        } else if (response.status === 400) {
          setLoading(false);
          setIsDisabled(false);
          toast.error(response.data.message);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      setIsDisabled(false);
    }
  };

  const handlePlayClick = (index) => {
    const video = document.querySelector(`#video-${index}`);
    const playButton = document.querySelector(`#play-button-${index}`);

    if (currentVideoIndex !== null && currentVideoIndex !== index) {
      // Pause the current video if another video is clicked
      const currentVideo = document.querySelector(
        `#video-${currentVideoIndex}`
      );
      currentVideo.pause();
    }

    if (video.paused) {
      video.play();
      setCurrentVideoIndex(index);
      playButton.style.display = "none";

      video.onended = () => {
        playButton.style.display = "block";
      };
    } else {
      video.pause();
      playButton.style.display = "block"; // Show play button if video is paused
      setCurrentVideoIndex(null); // Reset current video index
    }
  };

  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

  return (
    <>
      <DashboardHeader toggle={sidebarToggle}  {...(game && { game })} />
      {!game_id &&
      <PageHeaderTitle title={postId ? t("Update Post") : t("create_post")} />
      }
      <PageContainer gamePage={game_id && true}>
          {game_id && <GameSideBar activeMenu="feeds" slug={slug} />}
          <div>
        <div className=" md:block  rounded-2xl bg-white max-w-[60rem] mx-auto">
          <div
            className={
              isMobileView
                ? "py-4 mb-5 px-2 max-w-[65rem] bg-white mx-auto"
                : "mt-2 ml-3 py-4 max-w-[65rem] bg-white"
            }
          >
            <div style={{ display: "flex", alignItems: "center" }}>
            {!game_id && (
              <img
                src={"/qushi_logo.png"}
                alt="logo"
                style={{ width: "70px", height: "70px", marginRight: "10px" }}
              />
              )}
              {}
              {SUBSCRIPTION_ENABLED ? (
                <div>
                  <select
                    value={postStatus}
                    onChange={dropdownHandler}
                    style={dropdownStyle}
                  >
                    <option value="1">{t("Public")}</option>
                    <option value="2">{t("private")}</option>
                  </select>
                </div>
              ) : null}
            </div>
            <p className="text-xs text-gray-500 pt-2 p-2">
              {t("whats_on_your_mind")}
            </p>

            <div>
              <textarea
                id="description"
                rows="8"
                className="border border-gray-300 rounded-xl px-4 py-3 w-full h-54"
                placeholder="Enter your text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
            <div>
              <p className="text-xs text-gray-500 pt-2 p-2">
                {t("Add Images/Videos")}
              </p>
            </div>

            <div className="flex flex-col md:flex-row md:flex-wrap">
              {flutter ? (
                <div
                  className={
                    isMobileView ? "md:w-1/3 p-4" : "md:w-1/3 p-4 border-r"
                  }
                >
                  <label
                    htmlFor="upload"
                    onClick={() => event("imageUploadPost")}
                    className="block text-center py-3 rounded-xl border border-2 border-gray-400 cursor-pointer"
                  >
                    <input
                      type="file"
                      id="upload"
                      accept="image/*,video/*"
                      multiple
                      onChange={handleImageUpload}
                      className="hidden"
                      disabled={true}
                    />
                    <span className="text-gray-400 text-6xl font-normal">
                      <FontAwesomeIcon
                        icon={faPlus}
                        style={{ fontWeight: "300" }}
                      />
                    </span>
                  </label>
                </div>
              ) : (
                <div
                  className={
                    isMobileView ? "md:w-1/3 p-4" : "md:w-1/3 p-4 border-r"
                  }
                >
                  <label
                    htmlFor="upload"
                    className="block text-center py-3 rounded-xl border border-2 border-gray-400 cursor-pointer"
                  >
                    <input
                      type="file"
                      id="upload"
                      accept="image/*,video/*"
                      multiple
                      onChange={handleImageUpload}
                      className="hidden"
                    />

                    <span className="text-gray-400 text-6xl font-normal">
                      <FontAwesomeIcon
                        icon={faPlus}
                        style={{ fontWeight: "300" }}
                      />
                    </span>
                  </label>
                </div>
              )}

              <div className="md:w-2/3 flex flex-wrap">
                {loading && <Loader />}
                {images.map((img, index) => {
                  return (
                    <div key={index} className="w-full md:w-1/3 p-4 relative">
                      {img?.blob?.name ? (
                        <>
                          {videoExtensionsRegex.test(img?.blob?.name.split('?')[0]) ? (
                            <>
                              <div class="relative">
                                <video
                                  autobuffer
                                  playsInline={true}
                                  webkit-playsinline="true"
                                  x5-playsinline="true"
                                  x-webkit-airplay="deny"
                                  disablePictureInPicture={true}
                                  controlsList="nodownload"
                                  onContextMenu={(e) => e.preventDefault()}
                                  preload="auto"
                                  id={`video-${index}`}
                                  controls
                                  className="w-full h-52 rounded-lg"
                                  onClick={(e) => {
                                    // Reset video playback to start from 0 seconds
                                    e.target.currentTime = 0;
                                    // Handle play click event
                                    handlePlayClick(index);
                                  }}
                                >
                                  <source src={img?.preview} />
                                </video>
                                {isMobileView ? (
                                  ""
                                ) : (
                                  <button
                                    id={`play-button-${index}`}
                                    className="absolute rounded-lg inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white"
                                    style={{ display: "block" }}
                                    onClick={() => handlePlayClick(index)}
                                  >
                                    <FontAwesomeIcon
                                      className="h-7"
                                      icon={faPlay}
                                    />
                                  </button>
                                )}
                              </div>
                              <button
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                              >
                                &times;
                              </button>
                            </>
                          ) : (
                            <>
                              <img
                                src={img?.preview}
                                alt={`Preview ${index}`}
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />
                              <button
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                              >
                                &times;
                              </button>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {videoExtensionsRegex.test(img?.preview.split('?')[0]) ? (
                            <>
                              <div class="relative">
                                <video
                                  autobuffer
                                  playsInline={true}
                                  webkit-playsinline="true"
                                  x5-playsinline="true"
                                  x-webkit-airplay="deny"
                                  disablePictureInPicture={true}
                                  controlsList="nodownload"
                                  onContextMenu={(e) => e.preventDefault()}
                                  preload="auto"
                                  id={`video-${index}`}
                                  controls
                                  className="w-full h-52 rounded-lg"
                                  onClick={(e) => {
                                    // Reset video playback to start from 0 seconds
                                    e.target.currentTime = 0;
                                    // Handle play click event
                                    handlePlayClick(index);
                                  }}
                                >
                                  <source src={img?.preview} />
                                </video>
                                {isMobileView ? (
                                  ""
                                ) : (
                                  <button
                                    id={`play-button-${index}`}
                                    className="absolute inset-0 rounded-lg flex items-center justify-center bg-black bg-opacity-50 text-white"
                                    style={{ display: "block" }}
                                    onClick={() => handlePlayClick(index)}
                                  >
                                    <FontAwesomeIcon
                                      className="h-7"
                                      icon={faPlay}
                                    />
                                  </button>
                                )}
                              </div>
                              <button
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                              >
                                &times;
                              </button>
                            </>
                          ) : (
                            <>
                              <img
                                src={img?.preview}
                                alt={`Preview ${index}`}
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />
                              <button
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                              >
                                &times;
                              </button>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="socialMedia"
                name="socialMedia"
                className="rounded-md border-gray-300 text-gray-500 w-4"
              />
              <label
                htmlFor="socialMedia"
                className="ml-2 text-xs text-gray-500 font-normal inline-block"
              >
                {t("share_to_other_social_media_(X_TikTok_Instagram)")}
              </label>
            </div>
            <div className="text-center pr-0 mb-0">
              <button
                disabled={!isDisabled ? false : true}
                onClick={handleCreateOrUpdatePost}
                type="submit"
                className="w-full  text-center mt-4 bg-teal-800 border-teal-800 hover:bg-teal-900 hover:border-teal-900 text-white font-poppins text-sm rounded py-3"
              >
                {t("submit")}
              </button>
            </div>
            <div className={isMobileView ? "mb-12" : "mb-2"}></div>
          </div>
        </div>
        </div>
      </PageContainer>
      {isPreviewVideo && (
        <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
      )}
    </>
  );
};

export default CreatePostPage;
